/**
 * Shared metadata for the Terms of Service and Privacy Policy pages.
 *
 * These documents are a good-faith starting point, not legal advice. Review
 * them (ideally with a lawyer) before relying on them, and keep `updated` in
 * sync whenever the documents change materially.
 *
 * The contact address itself lives in `lib/contact.ts`, since it is also used
 * outside the legal pages.
 */
export const LEGAL = {
  /** Human-readable "last updated" date shown on both documents. */
  updated: "October 30, 2026",
} as const;
